<template>
  <div class="pages" :class="{ 'open': openOptions }">
    <div class="pages-inner">
      <button class="dots" @click="toggleOpenOptions($event)">
        <img src="@/assets/images/page_config_icon.svg" class="config-icon">
      </button>
      <span class="text">
           {{startIndex}}-{{endIndex}} {{$t('OF')}} {{numOfResult}}
        </span>
      <div class="arrows">
        <button @click="goPrev($event)" :class="{disabled: startIndex==1}">
          <img class="right-arrow" src="@/assets/images/arrow_next_page.svg">
        </button>
        <button @click="goNext($event)" :class="{disabled: endIndex==numOfResult}">
          <img class="left-arrow" src="@/assets/images/arrow_next_page.svg">
        </button>
      </div>
    </div>
    <ul class="pages-list">
      <li class="pages-item" v-for="(option, index) in paginationOptions" :key="index"
          :class="{active: option==selectedCount}" @click="changeSelectedCount($event,option)">
        {{option}} {{$t('IN_PAGE')}}
      </li>
    </ul>
  </div>
</template>

<script>
import { paginationOptions } from '@/constants'

export default {
  name: 'pagination-options',

  data () {
    return {
      paginationOptions: paginationOptions
    }
  },

  props: {
    openOptions: {
      type: Boolean,
      default: null
    },
    startIndex: {
      type: Number,
      default: 1
    },
    numOfResult: {
      type: Number,
      required: true
    },
    endIndex: {
      type: Number,
      default: null
    },
    selectedCount: {
      type: Number,
      default: paginationOptions[0]
    }
  },

  methods: {
    toggleOpenOptions (event) {
      event.stopPropagation()
      this.$emit('toggleOpenOptions')
    },
    goPrev (event) {
      event.stopPropagation()
      if (this.startIndex === 1) return false
      else this.$emit('goPrev', this.selectedCount)
    },
    goNext (event) {
      event.stopPropagation()
      if (this.endIndex === this.numOfResult) return false
      else this.$emit('goNext', this.selectedCount)
    },
    changeSelectedCount (event, option) {
      event.stopPropagation()
      this.$emit('changeSelectedCount', option)
    }
  }
}
</script>

<style scoped>

</style>
